export const styles = {
  root: {
    width: "30px",
    height: "30px !important",
    borderRadius: "50% ",
    "& > div": {
      padding: "0px ",
    },
    "& a": {
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& svg": {
      width: "18px",
      height: "18px",
    },
  },
};
